import { render, staticRenderFns } from "./EditGradeData.vue?vue&type=template&id=2fe8d5fe&scoped=true&"
import script from "./EditGradeData.vue?vue&type=script&lang=js&"
export * from "./EditGradeData.vue?vue&type=script&lang=js&"
import style0 from "./EditGradeData.vue?vue&type=style&index=0&id=2fe8d5fe&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe8d5fe",
  null
  
)

export default component.exports